import { ReactNode, useContext } from 'react';
import { ConfigContext } from 'src/configContext.ts';
import { SelectionV1 } from 'src/projects/types/Selection';
import { SelectionDataContext, SelectionDataValue } from 'src/projects/components/SelectionDataContext.ts';
import { ValveProvider } from 'src/projects/components/providers/ValveProvider.tsx';
import { ActuatorProvider } from 'src/projects/components/providers/ActuatorProvider.tsx';
import { SensorProvider } from 'src/projects/components/providers/SensorProvider.tsx';
import { RetrofitProvider } from 'src/projects/components/providers/RetrofitProvider.tsx';

export type ProviderProps = {
    selection: SelectionV1;
    children: ReactNode;
};

export const Provide = ({ value, children }: { value: SelectionDataValue; children: ReactNode }) => (
    <SelectionDataContext.Provider value={value}>{children}</SelectionDataContext.Provider>
);

export const SelectionDataProvider = ({ selection, children }: ProviderProps) => {
    const { userSettings } = useContext(ConfigContext);

    if (userSettings.shoppingCenter === null) {
        return children;
    }

    switch (selection.type) {
        case 'valves':
            return <ValveProvider selection={selection}>{children}</ValveProvider>;
        case 'actuators':
            return <ActuatorProvider selection={selection}>{children}</ActuatorProvider>;
        case 'sensors':
            return <SensorProvider selection={selection}>{children}</SensorProvider>;
        case 'retrofit_actuators':
            return <RetrofitProvider selection={selection}>{children}</RetrofitProvider>;
        case 'retrofit_sensors':
            return <RetrofitProvider selection={selection}>{children}</RetrofitProvider>;
        case 'retrofit_valves':
            return <RetrofitProvider selection={selection}>{children}</RetrofitProvider>;
        default:
            return children;
    }
};
